import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';


@Injectable({
  providedIn: 'root'
})
export class AppService {


  constructor(private toastController: ToastController) { }

  async toastMessage(message) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      cssClass: 'custom-toast-css'
    });
    toast.present();
  }


  checkLocalPassword() {
    let localPassword = JSON.parse(localStorage.getItem('password'));
    return localPassword;
  }

}
